import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import Layout from "../Layout/Layout";
import classes from "./AccountSettings.module.css";
import { Button } from "../../../stories/Button/Button";
import EditPhotoModal from "../../../components/Modals/CoachFlow/OnBoarding/EditPhoto/EditPhoto";
import { Input } from "../../../stories/Input/Input";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import DisableAccountModal from "../../../components/Modals/CoachFlow/Settings/DisableAccount/DisableAccount";
import {
  Arrowlinkicon,
  coachDemoImg,
  TrashIconGray,
  UserIconRed,
} from "../../../constant/imagePath";

const AccountSettings = () => {
  const coverRef = useRef(null);
  const [coverPhoto, setCoverPhoto] = useState(coachDemoImg);

  const [fullName, setFullName] = useState("Hanna Specter");
  const [phoneNumber, setPhoneNumber] = useState("+16102458015");
  const [gender, setGender] = useState({ label: "Male", value: "Male" });
  const [dateOfBirth, setDateOfBirth] = useState("22/04/1992");
  const [email, setEmail] = useState("john.johnson@gmail.com");
  const [aboutMe, setAboutMe] = useState("");

  const [sportsType, setSportsType] = useState();
  const [experienceLevel, setERxperienceLevel] = useState();

  const [password, setPassword] = useState();
  const [newpassword, setNewPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();

  const [disableModal, setDisableModal] = useState(false);

  const [isEditingCover, setIsEditingCover] = useState(false);
  const addCoverPhoto = () => {
    coverRef.current.click();
  };

  const deleteCoverPhoto = () => {
    setCoverPhoto(null);
  };

  return (
    <>
      <div className={classes.AdminTableMain}>
        <Layout />
        <div className={classes.tableMain}>
          <Container fluid className={[classes.container]}>
            <Row>
              <Col md={12}>
                <h3
                  className={classes.marginBlock24}
                  style={{ color: Colors.neutralShadesOfNero, ...Fonts.h3 }}
                >
                  Account settings
                </h3>
              </Col>
              <Col md={12}>
                <div className={[classes.editPhotoMainDiv]}>
                  <div className={classes.imageUpdated}>
                    <img
                      src={coverPhoto}
                      onError={(e) => (e.target.src = UserIconRed)}
                    />
                  </div>

                  <div className={classes.editPhotoInnerDiv}>
                    <h5
                      style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                    >
                      Add your profile pic
                    </h5>
                    <p
                      style={{
                        color: Colors.neutralShadesOfDimGray,
                        ...Fonts.p1,
                      }}
                    >
                      Upliad PNG or JPEG file. File size limit is up to 5MB
                    </p>
                    <div className={classes.imageControls}>
                      <Button
                        onClick={addCoverPhoto}
                        primary={true}
                        size={'Medium'}
                        label="Upload new picture"
                        customStyle={{
                          marginRight: "8px",
                          width: "max-content",
                          padding: "14px 24px",
                        }}
                      />
                      <Button
                        icon={TrashIconGray}
                        onClick={deleteCoverPhoto}
                        primary={false}
                        size={'Medium'}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <input
                  className="d-none"
                  accept="image/*"
                  type={"file"}
                  ref={coverRef}
                  onChange={(e) => {
                    console.log("aaa");
                    setCoverPhoto(e.target.files[0]);
                    setIsEditingCover(true);
                  }}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                />
              </Col>

              {/* Copy From Settings */}
              <Col md={12} className={classes.formRow}>
                <Row>
                  <Col lg={6} xl={5} className={[classes.formCol]}>
                    <Input
                      label="Full Name"
                      state={fullName}
                      setter={setFullName}
                      placeholder=""
                    />
                  </Col>
                  <Col lg={6} xl={5} className={[classes.formCol]}>
                    <Input
                      label="Phone Number (Optional)"
                      state={phoneNumber}
                      setter={setPhoneNumber}
                      placeholder=""
                    />
                  </Col>
                  <Col lg={6} xl={5} className={[classes.formCol]}>
                    <DropDown
                      label="Gender"
                      state={gender}
                      setter={setGender}
                      options={[
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                        { label: "Other", value: "Other" },
                      ]}
                    />
                  </Col>
                  <Col lg={6} xl={5} className={[classes.formCol]}>
                    <Input
                      label="Email address"
                      state={email}
                      setter={setEmail}
                      placeholder=""
                    />
                  </Col>
                  <Col lg={6} xl={5}>
                    <Button
                      primary={true}
                      disabled={true}
                      label="Save changes"
                      customStyle={{
                        width: "180px",
                        padding: "0px",
                        ...Fonts.b3,
                        lineHeight: '32px'
                      }}
                    />
                  </Col>
                </Row>
              </Col>

              <Col md={12}>
                <Row>
                  {/* Privacy Settings Form */}
                  <Col lg={6} xl={6} className={classes.mb32}>
                    <h5
                      style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
                      className={`${classes.mb32}`}
                    >
                      Privacy Settings
                    </h5>
                    <Input
                      type="password"
                      state={password}
                      setter={setPassword}
                      label="Current password"
                      placeholder={"Enter current password"}
                    />
                  </Col>
                  <Row>
                    <Col lg={6} xl={6} className={classes.mb32}>
                      <Input
                        type="password"
                        state={newpassword}
                        setter={setNewPassword}
                        label="New password"
                        placeholder={"Enter new password"}
                      />
                    </Col>
                    <Col lg={6} xl={6} className={classes.mb32}>
                      <Input
                        type="password"
                        state={confirmpassword}
                        setter={setConfirmPassword}
                        label="Confirm New password"
                        placeholder={"Re-enter new password"}
                      />
                    </Col>
                  </Row>
                  <Col md={12}>
                    <div
                      className={[classes.BtnDiv]}
                      style={{
                        borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                      }}
                    >
                      <Button
                        primary={false}
                        size={'Large'}
                        customStyle={{
                          width: "max-content", padding: "12px 36px",
                          marginRight: "16px",
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        primary={true}
                        size={'Large'}
                        customStyle={{ width: "max-content", padding: "12px 36px" }}
                      >
                        Save changes
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col md={12}>
                <div className={[classes.dflex, classes.mb80].join(" ")}>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                    className={[classes.mr10].join(" ")}
                  >
                    Can't remember your current password?
                  </p>
                  <LinkButtonWithIcon
                    rightIcon={Arrowlinkicon}
                    text="Reset password via email"
                    primary={true}
                    customStyle={{
                      ...Fonts.p1,
                      fontSize: "16px",
                      lineHeight: "16px",
                      fontFamily: 'inter-500'
                    }}
                  />
                </div>
              </Col>
            </Row>

            {/* Edit Photo Modal */}
            {isEditingCover && (
              <EditPhotoModal
                show={isEditingCover}
                setShow={setIsEditingCover}
                state={coverPhoto}
                onSave={setCoverPhoto}
              />
            )}

            <DisableAccountModal
              show={disableModal}
              setShow={setDisableModal}
            />
          </Container>
        </div>
      </div >
    </>
  );
};

export default AccountSettings;
